import { t } from 'i18next';
import { useState } from 'react';

import { toast } from 'react-toastify';

import { Button, Input, Select } from '~/components';
import { apiCall } from '~/providers';

export const FormEditDut = ({
  dutInfo, unitInfo, unitsList, roomTypes, environmentCategories, onSuccess, onCancel,
}): JSX.Element => {
  const [, stateChanged] = useState({});
  const [state] = useState({
    changed() { stateChanged({}); },
    submitting: false,
    formData: {
      DEV_ID: dutInfo?.DEV_ID ?? null,
      ROOM_NAME: dutInfo?.ROOM_NAME ?? '',
      unit: unitInfo?.UNIT_ID ? unitsList.find((unit) => unit.UNIT_ID === unitInfo.UNIT_ID) ?? null : null,
      roomType: dutInfo?.RTYPE_ID ? roomTypes.find((item) => item.RTYPE_ID === dutInfo.RTYPE_ID) ?? null : null,
      environmentCategory: dutInfo?.CATEGORY_ID ? environmentCategories?.find((item) => item.value === dutInfo.CATEGORY_ID) ?? null : null,
    },
  });

  const { formData } = state;

  function validateCategory() {
    if (!formData.environmentCategory) {
      toast.error(t('erroSalvarAmbienteSemCategoria'));
      return false;
    }
    return true;
  }

  async function confirm() {
    let response = null as null|string;
    let action = null;
    try {
      state.submitting = true; state.changed();
      const reqData = {
        DEV_ID: formData.DEV_ID,
        UNIT_ID: formData.unit && formData.unit.UNIT_ID,
        ROOM_NAME: formData.ROOM_NAME || null,
        RTYPE_ID: (formData.roomType && formData.roomType.RTYPE_ID) || null,
        CATEGORY_ID: formData.environmentCategory?.value ?? null,
        CLIENT_ID: dutInfo.CLIENT_ID,
      };
      // @ts-ignore
      action = 'set';
      if (dutInfo.DEV_ID === '-') {
        if (!validateCategory()) return;
        response = await apiCall('/environments/edit-environment', {
          ENVIRONMENT_ID: dutInfo.ENVIRONMENT_ID,
          ENVIRONMENT_NAME: reqData.ROOM_NAME,
          RTYPE_ID: reqData.RTYPE_ID,
          CATEGORY_ID: reqData.CATEGORY_ID,
          UNIT_ID: reqData.UNIT_ID,
          CLIENT_ID: dutInfo.CLIENT_ID,
        });
      }
      if (dutInfo.DEV_ID.startsWith('DUT')) {
        if (!validateCategory()) return;
        // @ts-ignore
        response = await apiCall('/dut/set-dut-info', { ...reqData, ENVIRONMENT_ID: dutInfo.ENVIRONMENT_ID || undefined }).then((data) => ({ data }));
      }
      if (dutInfo.DEV_ID.startsWith('DRI')) {
        await apiCall('/dri/set-dri-info', { DRI_ID: formData.DEV_ID, UNIT_ID: formData.unit && formData.unit.UNIT_ID });
        response = await apiCall('/dri/update-dri-vav', { VAV_ID: formData.DEV_ID, ROOM_NAME: formData.ROOM_NAME || null, RTYPE_ID: (formData.roomType && formData.roomType.RTYPE_ID) || null });
      }
    } catch (err) { console.log(err); toast.error(t('houveErro')); }
    state.submitting = false; state.changed();
    // @ts-ignore
    if (response && action) onSuccess({ item: response.data, action });
  }

  return (
    <div>
      {unitsList
        && (
        <Select
          options={unitsList}
          propLabel="UNIT_NAME"
          value={formData.unit}
          placeholder={t('unidade')}
          onSelect={(item) => { toast.warn(t('avisoAlterarUnidadeAmbiente')); state.formData.unit = item; state.changed(); }}
        />
        )}
      <Input
        type="text"
        style={{ marginTop: '10px' }}
        value={formData.ROOM_NAME}
        placeholder={t('nomeAmbiente')}
        onChange={(event) => { state.formData.ROOM_NAME = event.target.value; state.changed(); }}
      />
      {(roomTypes.length > 0)
        && (
        <Select
          style={{ marginTop: '10px' }}
          options={roomTypes}
          propLabel="RTYPE_NAME"
          value={formData.roomType}
          placeholder={t('tipoAmbiente')}
          onSelect={(item) => { state.formData.roomType = item; state.changed(); }}
        />
        )}
      {(environmentCategories?.length > 0 && !formData.DEV_ID?.startsWith('DRI'))
        && (
        <Select
          style={{ marginTop: '10px' }}
          options={environmentCategories}
          propLabel="name"
          value={formData.environmentCategory}
          placeholder={t('categoriaAmbiente')}
          onSelect={(item) => { state.formData.environmentCategory = item; state.changed(); }}
        />
        )}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '30px',
      }}
      >
        {/* eslint-disable-next-line react/jsx-no-bind */}
        <Button style={{ width: '140px' }} onClick={confirm} variant="primary">
          {t('salvar')}
        </Button>
        {/* @ts-ignore */}
        <Button style={{ width: '140px', margin: '0 20px' }} onClick={onCancel} variant="grey">
          {t('cancelar')}
        </Button>
      </div>
    </div>
  );
};
